import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
/**
 * Getters
 */
export const _ContentRatingSystemGetter = Getter.of();
export const _ContentRatingSystemResponseGetter = Getter.of();
/**
 * Lenses
 */
export const _ContentRatingSystem2Data = Fold.compose(_ContentRatingSystemGetter, Res._Response());
export const _ContentRatingSystem2Attributes = Fold.compose(_ContentRatingSystem2Data, Lens.prop("attributes"));
export const _ContentRatingSystemAttributes2System = Fold.compose(_ContentRatingSystem2Attributes, Lens.prop("system"));

